import httpClient from '../http/http-client'
import { ICreateNote, INote, INoteCounts, INoteQuery, IUpdateNote, NoteParent } from './note.model'

export default class NoteService {
  http

  constructor() {
    this.http = httpClient
  }

  async getAll(params: INoteQuery): Promise<INote[]> {
    const query = new URLSearchParams({ relatedModelName: params.relatedModelName, relatedObjectId: params.relatedObjectId })
    if (params.reportPeriodId) query.set('reportPeriodId', params.reportPeriodId)
    if (params.groupId) query.set('groupId', params.groupId)
    return this.http.get(`note?${query.toString()}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  }

  /** Note counts and the latest note per record, for table indicators. At most 200 ids. */
  async getCounts(relatedModelName: NoteParent, ids: string[]): Promise<INoteCounts> {
    if (ids.length === 0) return {}
    const query = new URLSearchParams({ relatedModelName, ids: ids.join(',') })
    return this.http.get(`note/counts?${query.toString()}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  }

  async create(payload: ICreateNote): Promise<INote> {
    return this.http.post(`note`, payload)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  }

  async update(id: string, payload: IUpdateNote): Promise<INote> {
    return this.http.patch(`note/${id}`, payload)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err
      })
  }

  /** Soft delete: the note disappears from the record and from every report. */
  async remove(id: string): Promise<void> {
    return this.http.delete(`note/${id}`)
      .then(() => undefined)
      .catch(err => {
        console.log(err)
        throw err
      })
  }
}
